// extracted by mini-css-extract-plugin
module.exports = {"bubbles":"MainTabArea_bubbles__3kkMv","bubble":"MainTabArea_bubble__1Abw-","container":"MainTabArea_container__1kF4R","input":"MainTabArea_input__11bUl"};